/**
 * MPCI Monetary Amount Type — Full list from DB extraction
 * Source: mpci_db_all_sheets.json (Statuses sheet)
 * Separated from cargoOptions.js due to size (550+ codes)
 */
export const MONETARY_AMOUNT_TYPE = [
  { value: '1',   text: '1 - VAT, 1st value' },
  { value: '2',   text: '2 - VAT, 2nd value' },
  { value: '3',   text: '3 - VAT, 3rd value' },
  { value: '4',   text: '4 - Additional royalties' },
  { value: '5',   text: '5 - Adjusted amount' },
  { value: '6',   text: '6 - Amount reference currency' },
  { value: '7',   text: '7 - Agreed charge' },
  { value: '8',   text: '8 - Allowance or charge' },
  { value: '9',   text: '9 - Amount due or amount owed' },
  { value: '10',  text: '10 - Amount in charge currency' },
  { value: '11',  text: '11 - Amount paid' },
  { value: '12',  text: '12 - Amount remitted' },
  { value: '13',  text: '13 - Amount subject to tax' },
  { value: '14',  text: '14 - Amount target currency' },
  { value: '15',  text: '15 - Average ledger balance' },
  { value: '16',  text: '16 - Bank release fee' },
  { value: '17',  text: '17 - Batch total' },
  { value: '18',  text: '18 - Brokerage' },
  { value: '19',  text: '19 - Buying commission' },
  { value: '20',  text: '20 - Data value on carrier' },
  { value: '21',  text: '21 - Cash discount' },
  { value: '22',  text: '22 - Consignment cash on delivery' },
  { value: '23',  text: '23 - Charge amount' },
  { value: '24',  text: '24 - Charge summary total' },
  { value: '25',  text: '25 - Charge or allowance' },
  { value: '26',  text: '26 - Charges collect fee' },
  { value: '27',  text: '27 - Charges in destination currency' },
  { value: '28',  text: '28 - Collect charge subtotal' },
  { value: '29',  text: '29 - Collect charges in weight break' },
  { value: '30',  text: '30 - Collect freight charges' },
  { value: '31',  text: '31 - Collect freight charges in destination currency' },
  { value: '32',  text: '32 - Collect other charges' },
  { value: '33',  text: '33 - Collect taxes total' },
  { value: '34',  text: '34 - Collected balance' },
  { value: '35',  text: '35 - Container cost' },
  { value: '36',  text: '36 - Converted amount' },
  { value: '37',  text: '37 - Credit on consignment' },
  { value: '39',  text: '39 - Invoice total amount' },
  { value: '40',  text: '40 - Goods item for customs' },
  { value: '41',  text: '41 - Assigned customs value' },
  { value: '42',  text: '42 - Total cash payments' },
  { value: '43',  text: '43 - Consignment for customs' },
  { value: '44',  text: '44 - Goods item for carrier' },
  { value: '45',  text: '45 - Deductible after purchase' },
  { value: '46',  text: '46 - Customs allowable value' },
  { value: '47',  text: '47 - Delivery fee' },
  { value: '48',  text: '48 - Deposit total' },
  { value: '49',  text: '49 - Development necessary' },
  { value: '50',  text: '50 - Disbursements' },
  { value: '51',  text: '51 - Disbursements fee' },
  { value: '52',  text: '52 - Discount amount' },
  { value: '53',  text: '53 - Discount amount due' },
  { value: '54',  text: '54 - Distribution service charge' },
  { value: '55',  text: '55 - Duty amount' },
  { value: '56',  text: '56 - Duty or tax or fee' },
  { value: '57',  text: '57 - Equivalent amount' },
  { value: '58',  text: '58 - Fee amount' },
  { value: '59',  text: '59 - Fees paid year to date' },
  { value: '60',  text: '60 - Final (posted) amount' },
  { value: '61',  text: '61 - Float (cash float)' },
  { value: '62',  text: '62 - Total payments on account' },
  { value: '63',  text: '63 - FOB value' },
  { value: '64',  text: '64 - Freight charge' },
  { value: '65',  text: '65 - Total indirect amount' },
  { value: '66',  text: '66 - Goods item total' },
  { value: '67',  text: '67 - Insurance amount' },
  { value: '68',  text: '68 - Insurance and transport charges' },
  { value: '69',  text: '69 - Insurance and transport charges combined' },
  { value: '70',  text: '70 - Consignment to importer' },
  { value: '71',  text: '71 - Insurance charges' },
  { value: '72',  text: '72 - Internal charges' },
  { value: '73',  text: '73 - Total amount of premiums' },
  { value: '74',  text: '74 - Amount to be paid' },
  { value: '75',  text: '75 - Registered capital' },
  { value: '76',  text: '76 - Investable balance' },
  { value: '77',  text: '77 - Invoice line item amount' },
  { value: '78',  text: '78 - Landing charges' },
  { value: '79',  text: '79 - Total line items amounts' },
  { value: '80',  text: '80 - Licence fees related to goods' },
  { value: '81',  text: '81 - Loading and handling charges' },
  { value: '82',  text: '82 - Lock box total' },
  { value: '83',  text: '83 - Lumpsum' },
  { value: '84',  text: '84 - Material consumed' },
  { value: '85',  text: '85 - Maximum charge' },
  { value: '86',  text: '86 - Message total monetary amount' },
  { value: '87',  text: '87 - Minimum charge' },
  { value: '88',  text: '88 - National preference customs value' },
  { value: '89',  text: '89 - Negative collected balance' },
  { value: '90',  text: '90 - Negative ledger balance' },
  { value: '91',  text: '91 - Net adjustment' },
  { value: '92',  text: '92 - Net fee position' },
  { value: '93',  text: '93 - Net year to date amount' },
  { value: '94',  text: '94 - No amount of insurance' },
  { value: '95',  text: '95 - No declared value for carriage' },
  { value: '96',  text: '96 - No declared value for customs' },
  { value: '97',  text: '97 - Quotation total amount' },
  { value: '98',  text: '98 - Original amount' },
  { value: '99',  text: '99 - Other charges at destination' },
  { value: '100', text: '100 - Other charges due agent' },
  { value: '101', text: '101 - Other charges due carrier' },
  { value: '102', text: '102 - Other commissions' },
  { value: '103', text: '103 - Other deductible' },
  { value: '104', text: '104 - Other transport charges' },
  { value: '105', text: '105 - Other valuation charges' },
  { value: '106', text: '106 - Packing cost' },
  { value: '107', text: '107 - Transport equipment repair cost' },
  { value: '108', text: '108 - Parts incorporated' },
  { value: '109', text: '109 - Payment discount' },
  { value: '110', text: '110 - Pick-up fee' },
  { value: '111', text: '111 - Positive collected balance' },
  { value: '112', text: '112 - Positive ledger balance' },
  { value: '113', text: '113 - Prepaid amount' },
  { value: '114', text: '114 - Prepaid charge subtotal' },
  { value: '115', text: '115 - Prepaid taxes total' },
  { value: '116', text: '116 - Purchase amount' },
  { value: '117', text: '117 - Quantity discount' },
  { value: '118', text: '118 - Quota value' },
  { value: '119', text: '119 - Received amount' },
  { value: '120', text: '120 - Sales tax' },
  { value: '121', text: '121 - Shipment value in transport currency' },
  { value: '122', text: '122 - Specific amount to be listed' },
  { value: '123', text: '123 - Goods item for statistical purposes' },
  { value: '124', text: '124 - Tax amount' },
  { value: '125', text: '125 - Taxable amount' },
  { value: '126', text: '126 - To collect' },
  { value: '127', text: '127 - Tools used in production' },
  { value: '128', text: '128 - Total amount' },
  { value: '129', text: '129 - Total amount subject to payment' },
  { value: '130', text: '130 - Total charge due' },
  { value: '131', text: '131 - Total charges or allowances' },
  { value: '132', text: '132 - Total collect charges' },
  { value: '133', text: '133 - Total collect charges in weight break' },
  { value: '134', text: '134 - Total declared' },
  { value: '135', text: '135 - Total freight due' },
  { value: '136', text: '136 - Total invoice adjustment amount' },
  { value: '137', text: '137 - Damage protection' },
  { value: '138', text: '138 - Total monetary discount' },
  { value: '139', text: '139 - Total payment amount' },
  { value: '140', text: '140 - Total service charges' },
  { value: '141', text: '141 - CIF (Cost, Insurance and Freight)' },
  { value: '142', text: '142 - Trade discount' },
  { value: '143', text: '143 - Transfer amount' },
  { value: '144', text: '144 - Transport charges' },
  { value: '145', text: '145 - Transport charges at destination' },
  { value: '146', text: '146 - Unit price' },
  { value: '147', text: '147 - Acceptable quotation amount' },
  { value: '148', text: '148 - Total payments up to date' },
  { value: '149', text: '149 - Valuation charge' },
  { value: '150', text: '150 - Value added tax amount' },
  { value: '151', text: '151 - Consignment insurance value' },
  { value: '152', text: '152 - Subsequent resale value' },
  { value: '153', text: '153 - Weight charge' },
  { value: '154', text: '154 - Amount to be collected' },
  { value: '155', text: '155 - Standard duty' },
  { value: '156', text: '156 - G-Amount' },
  { value: '157', text: '157 - Insurance value' },
  { value: '158', text: '158 - Insurance and transport combined value' },
  { value: '159', text: '159 - Licence (value declared)' },
  { value: '160', text: '160 - Other costs' },
  { value: '161', text: '161 - Duty tax or fee amount (customs)' },
  { value: '162', text: '162 - Customs duty paid' },
  { value: '163', text: '163 - Wage tax share' },
  { value: '164', text: '164 - Social securities' },
  { value: '165', text: '165 - Adjustment amount' },
  { value: '166', text: '166 - Guarantee amount' },
  { value: '167', text: '167 - Actual versus contract value difference' },
  { value: '168', text: '168 - Tax sub-totals' },
  { value: '169', text: '169 - Alternate currency amount' },
  { value: '170', text: '170 - Document amount' },
  { value: '171', text: '171 - Total reassignment amount' },
  { value: '172', text: '172 - Stated amount' },
  { value: '173', text: '173 - Minimum amount' },
  { value: '174', text: '174 - Balance brought forward' },
  { value: '175', text: '175 - Message total adjustment amount' },
  { value: '176', text: '176 - Message total due amount' },
  { value: '177', text: '177 - Message total amount' },
  { value: '178', text: '178 - Exact amount' },
  { value: '179', text: '179 - Maximum amount' },
  { value: '180', text: '180 - Amount up to' },
  { value: '181', text: '181 - Amount not exceeding' },
  { value: '182', text: '182 - Any other specified amount' },
  { value: '183', text: '183 - No specification' },
  { value: '184', text: '184 - Final net acquisition amount' },
  { value: '185', text: '185 - Labour cost' },
  { value: '186', text: '186 - Material cost' },
  { value: '187', text: '187 - Other cost' },
  { value: '188', text: '188 - Overhead cost' },
  { value: '189', text: '189 - Packaging cost' },
  { value: '190', text: '190 - Prototype set up cost' },
  { value: '191', text: '191 - Authorized clean down cost' },
  { value: '192', text: '192 - Raw material percentage per unit' },
  { value: '193', text: '193 - Raw material per unit' },
  { value: '194', text: '194 - Total die model cost' },
  { value: '195', text: '195 - Total gauge cost' },
  { value: '196', text: '196 - Total material inspection cost' },
  { value: '197', text: '197 - Total purchased components cost' },
  { value: '198', text: '198 - Total tooling cost' },
  { value: '199', text: '199 - Delivery limitation' },
  { value: '200', text: '200 - Minimum amount due' },
  { value: '201', text: '201 - Penalty amount' },
  { value: '202', text: '202 - Interest amount' },
  { value: '203', text: '203 - Line item amount' },
  { value: '204', text: '204 - Allowance amount' },
  { value: '205', text: '205 - Additional amount 1' },
  { value: '206', text: '206 - Additional amount 2' },
  { value: '207', text: '207 - Additional amount 3' },
  { value: '208', text: '208 - Additional amount 4' },
  { value: '209', text: '209 - Agent commission amount' },
  { value: '210', text: '210 - Credit note amount' },
  { value: '211', text: '211 - Debit note amount' },
  { value: '212', text: '212 - Documentary credit amount' },
  { value: '213', text: '213 - Part of documentary credit' },
  { value: '214', text: '214 - Advance payment amount' },
  { value: '215', text: '215 - Deduction of advance payment' },
  { value: '216', text: '216 - Advance payment amount 2' },
  { value: '217', text: '217 - Deduction of advance payment 2' },
  { value: '218', text: '218 - Advance payment amount 3' },
  { value: '219', text: '219 - Deduction of advance payment 3' },
  { value: '220', text: '220 - Amount subject to total discount' },
  { value: '221', text: '221 - Amount not subject to discount' },
  { value: '222', text: '222 - Amount subject to exchange rate' },
  { value: '223', text: '223 - Works amount initial' },
  { value: '224', text: '224 - Works amount variation' },
  { value: '225', text: '225 - Works amount total' },
  { value: '226', text: '226 - Retention amount' },
  { value: '227', text: '227 - Deposit' },
  { value: '228', text: '228 - Deposit refund' },
  { value: '229', text: '229 - Guarantee on retention' },
  { value: '230', text: '230 - Amount subject to escalation' },
  { value: '231', text: '231 - Amount subject to price adjustment' },
  { value: '232', text: '232 - Amount of variation escalation' },
  { value: '233', text: '233 - Amount not subject to escalation' },
  { value: '234', text: '234 - Amount not subject to price adjustment' },
  { value: '235', text: '235 - Amount of variation price adjustment' },
  { value: '236', text: '236 - Amount subject to escalation (provisional)' },
  { value: '237', text: '237 - Amount subject to price adjustment (provisional)' },
  { value: '238', text: '238 - Amount of variation escalation (provisional)' },
  { value: '239', text: '239 - Amount not subject to escalation (provisional)' },
  { value: '240', text: '240 - Amount not subject to price adjustment (provisional)' },
  { value: '241', text: '241 - Amount of variation price adjustment (provisional)' },
  { value: '242', text: '242 - Escalation amount' },
  { value: '243', text: '243 - Provisional escalation' },
  { value: '244', text: '244 - Price adjustment amount' },
  { value: '245', text: '245 - Provisional price adjustment' },
  { value: '246', text: '246 - Price revaluation amount' },
  { value: '247', text: '247 - Provisional price revaluation' },
  { value: '248', text: '248 - Contractual retention' },
  { value: '249', text: '249 - Valuation amount' },
  { value: '250', text: '250 - Deduction amount' },
  { value: '251', text: '251 - Amortization total' },
  { value: '252', text: '252 - Amortization ordinary' },
  { value: '253', text: '253 - Amortization cumulated' },
  { value: '254', text: '254 - Current credit cover' },
  { value: '255', text: '255 - New credit cover' },
  { value: '256', text: '256 - Order cover' },
  { value: '257', text: '257 - Amount subject to transfer' },
  { value: '258', text: '258 - Charge amount for non-standard dimensions' },
  { value: '259', text: '259 - Total charges' },
  { value: '260', text: '260 - Total allowances' },
  { value: '261', text: '261 - Alternate currency amount' },
  { value: '262', text: '262 - Instalment amount' },
  { value: '263', text: '263 - Outstanding amount' },
  { value: '264', text: '264 - Gross contribution' },
  { value: '265', text: '265 - Commission amount' },
  { value: '266', text: '266 - Net contribution' },
  { value: '267', text: '267 - Regular contribution' },
  { value: '268', text: '268 - Previous regular contribution' },
  { value: '269', text: '269 - Variation amount' },
  { value: '270', text: '270 - Notional salary' },
  { value: '271', text: '271 - Nominal salary' },
  { value: '272', text: '272 - Taxable salary' },
  { value: '273', text: '273 - Superannuation salary' },
  { value: '274', text: '274 - Total remuneration' },
  { value: '275', text: '275 - Other salary' },
  { value: '276', text: '276 - Annual salary' },
  { value: '277', text: '277 - Total contribution' },
  { value: '278', text: '278 - Voluntary contribution' },
  { value: '279', text: '279 - Instalment first payment' },
  { value: '280', text: '280 - Instalment current payment' },
  { value: '281', text: '281 - Instalment last payment' },
  { value: '282', text: '282 - Current maintenance fee' },
  { value: '283', text: '283 - Current leasing fee' },
  { value: '284', text: '284 - Day works amount' },
  { value: '285', text: "285 - Manufacturer's base price" },
  { value: '286', text: '286 - Administration cost' },
  { value: '287', text: '287 - Fuel charge' },
  { value: '288', text: '288 - Registration plate charge' },
  { value: '289', text: '289 - Subtotal amount' },
  { value: '290', text: '290 - Dumping export value' },
  { value: '291', text: '291 - Foreign inland freight' },
  { value: '292', text: '292 - Concession amount' },
  { value: '293', text: '293 - Chargeback' },
  { value: '294', text: '294 - Charge per credit' },
  { value: '295', text: '295 - Charge per unused credit' },
  { value: '296', text: '296 - Total authorised amount' },
  { value: '297', text: '297 - Total chargebacks' },
  { value: '298', text: '298 - Total offsets' },
  { value: '299', text: '299 - Total special entries' },
  { value: '300', text: '300 - Balance carried forward' },
  { value: '301', text: '301 - Total outstanding amount' },
  { value: '302', text: '302 - Off balance disposition' },
  { value: '303', text: '303 - Commission invoices' },
  { value: '304', text: '304 - Other charges' },
  { value: '305', text: '305 - Amount remittances' },
  { value: '306', text: '306 - Total amount of debit entries' },
  { value: '307', text: '307 - Total amount of credit entries' },
  { value: '308', text: '308 - Total amount credited' },
  { value: '309', text: '309 - Total adjustment debit' },
  { value: '310', text: '310 - Total adjustment credit' },
  { value: '311', text: '311 - Total adjustment amount' },
  { value: '312', text: '312 - Base unit value' },
  { value: '313', text: '313 - International freight' },
  { value: '314', text: '314 - Own risk amount' },
  { value: '315', text: '315 - Opening balance' },
  { value: '316', text: '316 - Insurance premium' },
  { value: '317', text: '317 - Insurance commission' },
  { value: '318', text: '318 - Insurance tax' },
  { value: '319', text: '319 - Fee of insurer' },
  { value: '320', text: '320 - Fee of intermediary' },
  { value: '321', text: '321 - Debit flow' },
  { value: '322', text: '322 - Closing balance (credit)' },
  { value: '323', text: '323 - Opening balance (credit)' },
  { value: '324', text: '324 - Opening balance (debit)' },
  { value: '325', text: '325 - Closing balance (debit)' },
  { value: '326', text: '326 - Net assets and liabilities' },
  { value: '327', text: '327 - Adjustment to debit' },
  { value: '328', text: '328 - Adjustment to credit' },
  { value: '329', text: '329 - Credit flow' },
  { value: '330', text: '330 - Total prepaid other charges' },
  { value: '331', text: '331 - Total collect weight charges' },
  { value: '332', text: '332 - Total prepaid weight charges' },
  { value: '333', text: '333 - Total collect other charges' },
  { value: '334', text: '334 - Total prepaid other charges (2)' },
  { value: '335', text: '335 - Total collect valuation charges' },
  { value: '336', text: '336 - Total prepaid valuation charges' },
  { value: '337', text: '337 - Authorized clean down' },
  { value: '338', text: '338 - Escalated value' },
  { value: '339', text: '339 - Original invoice amount' },
  { value: '340', text: '340 - Original total net amount' },
  { value: '341', text: '341 - Offset value' },
  { value: '342', text: '342 - Non-taxable amount' },
  { value: '343', text: '343 - Closing balance' },
  { value: '344', text: '344 - Value date balance' },
  { value: '345', text: '345 - Cost information' },
  { value: '346', text: '346 - Total credits' },
  { value: '347', text: '347 - Total debits' },
  { value: '348', text: '348 - Booked amount on account' },
  { value: '349', text: '349 - Pending amount to book' },
  { value: '350', text: '350 - Damage repair cost' },
  { value: '351', text: '351 - Labour rate per hour' },
  { value: '352', text: '352 - Total equipment cost' },
  { value: '353', text: '353 - Total equipment time' },
  { value: '354', text: '354 - Add to make market value' },
  { value: '355', text: '355 - Pro-ratable value' },
  { value: '356', text: '356 - Deduct to make market value' },
  { value: '357', text: '357 - Interim opening balance' },
  { value: '358', text: '358 - Interim closing balance' },
  { value: '359', text: '359 - Balance to be collected' },
  { value: '360', text: '360 - Accrued debit interest' },
  { value: '361', text: '361 - Accrued credit interest' },
  { value: '362', text: '362 - Part of booked amount' },
  { value: '363', text: '363 - Increase of documentary credit' },
  { value: '364', text: '364 - Decrease of documentary credit' },
  { value: '365', text: '365 - New documentary credit amount' },
  { value: '366', text: '366 - Rounding amount' },
  { value: '367', text: '367 - Labour sales tax' },
  { value: '368', text: '368 - Material sales tax' },
  { value: '369', text: '369 - Goods and services tax' },
  { value: '370', text: '370 - State or provincial tax' },
  { value: '371', text: '371 - Amount to be transferred' },
  { value: '372', text: '372 - Direct debit transfer amount' },
  { value: '373', text: '373 - Total amount of transactions' },
  { value: '374', text: '374 - Total amount of credit transfers' },
  { value: '375', text: '375 - Total amount of direct debits' },
  { value: '376', text: '376 - Accounting entry amount' },
  { value: '377', text: "377 - Entry's expected settlement amount" },
  { value: '378', text: '378 - Closing date credit' },
  { value: '379', text: '379 - Closing date debit' },
  { value: '380', text: '380 - Total amount of entries' },
  { value: '381', text: '381 - Budget cost' },
  { value: '382', text: '382 - Actual cost' },
  { value: '383', text: '383 - Estimate cost' },
  { value: '384', text: '384 - Earned value cost' },
  { value: '385', text: '385 - Warranty repair cost' },
  { value: '386', text: '386 - Maximum amount insured' },
  { value: '387', text: '387 - Minimum amount insured' },
  { value: '388', text: '388 - Total amount including damages' },
  { value: '389', text: '389 - Amount excluding tax' },
  { value: '390', text: '390 - Minimum amount excluding tax' },
  { value: '391', text: '391 - Indemnity amount' },
  { value: '392', text: '392 - Sub-contracted amount' },
  { value: '393', text: '393 - Amount due for works' },
  { value: '394', text: '394 - Minimum order or contract' },
  { value: '395', text: '395 - Vending machine sales' },
  { value: '396', text: '396 - Total price subsidy' },
  { value: '397', text: '397 - Advertising amount' },
  { value: '398', text: '398 - Fixed sum advance' },
  { value: '399', text: '399 - Optional advance' },
  { value: '400', text: '400 - Rebate amount' },
  { value: '401', text: '401 - Penalty basis amount' },
  { value: '402', text: '402 - Total retail value' },
  { value: '403', text: '403 - Exemption amount' },
  { value: '404', text: '404 - Budget amount' },
  { value: '405', text: '405 - Value of services' },
  { value: '406', text: '406 - Maximum amount excluding tax' },
  { value: '407', text: '407 - Annual revenue' },
  { value: '408', text: '408 - Co-insurance commission' },
  { value: '409', text: '409 - Negotiated cost' },
  { value: '410', text: '410 - Estimated cost at completion' },
  { value: '411', text: '411 - Contract target cost' },
  { value: '412', text: '412 - Contract target fee' },
  { value: '413', text: '413 - Contract target price' },
  { value: '414', text: '414 - Final contract price' },
  { value: '415', text: '415 - Contract ceiling cost' },
  { value: '416', text: '416 - Contract ceiling price' },
  { value: '417', text: '417 - Contract cost to date' },
  { value: '418', text: '418 - Contract cost at completion (current)' },
  { value: '419', text: '419 - Contract cost at completion (latest revised estimate)' },
  { value: '420', text: '420 - Contract cost at completion (original)' },
  { value: '421', text: '421 - Contract cost at completion (authorized)' },
  { value: '422', text: '422 - Contract budget baseline' },
  { value: '423', text: '423 - Contract cost of work performed' },
  { value: '424', text: '424 - General and administrative' },
  { value: '425', text: '425 - Contract undistributed budget' },
  { value: '426', text: '426 - Contract management reserve' },
  { value: '427', text: '427 - Budget performance' },
  { value: '428', text: '428 - Budget cost cumulative' },
  { value: '429', text: '429 - Actual cost cumulative' },
  { value: '430', text: '430 - Earned value cost cumulative' },
  { value: '431', text: '431 - Cost variance' },
  { value: '432', text: '432 - Cost variance cumulative' },
  { value: '433', text: '433 - Contract replanned budget' },
  { value: '434', text: '434 - Contract replanned cost' },
  { value: '435', text: '435 - Budget cost at completion' },
  { value: '436', text: '436 - Contract negotiated change' },
  { value: '437', text: '437 - Contract target cost change' },
  { value: '438', text: '438 - Contract ceiling cost change' },
  { value: '439', text: '439 - Contract target price change' },
  { value: '440', text: '440 - Contract ceiling price change' },
  { value: '441', text: '441 - Open commitment amount' },
  { value: '442', text: '442 - Accrued expenditure' },
  { value: '443', text: '443 - Contract funds authorized' },
  { value: '444', text: '444 - Contract billing' },
  { value: '445', text: '445 - Contract termination liability' },
  { value: '446', text: '446 - Contract funds for next quarter' },
  { value: '447', text: '447 - Contract funds for next quarter (2)' },
  { value: '448', text: '448 - Contract total funds' },
  { value: '449', text: '449 - Contract funds committed' },
  { value: '450', text: '450 - Contract net funds' },
  { value: '451', text: '451 - Cost variance at completion' },
  { value: '452', text: '452 - Harmonized tariff schedule amount' },
  { value: '453', text: '453 - Agreed monetary amount' },
  { value: '454', text: '454 - Total debit charges amount' },
  { value: '455', text: '455 - Total debit allowances amount' },
  { value: '456', text: '456 - Total debit charges amount (2)' },
  { value: '457', text: '457 - Total debit allowances amount (2)' },
  { value: '458', text: '458 - Total debit charges amount (3)' },
  { value: '459', text: '459 - Total debit allowances amount (3)' },
  { value: '460', text: '460 - Total debit charges amount (4)' },
  { value: '461', text: '461 - Total debit allowances amount (4)' },
  { value: '462', text: '462 - Annual turnover' },
  { value: '463', text: '463 - Dispensing fee' },
  { value: '464', text: '464 - Gross premium' },
  { value: '465', text: '465 - Net premium' },
  { value: '466', text: '466 - Engineering fee amount' },
  { value: '467', text: '467 - Insurer paid tax' },
  { value: '468', text: '468 - Insurance fixed premium' },
  { value: '469', text: '469 - Insurance variable premium' },
  { value: '470', text: '470 - Negotiated contract value' },
  { value: '471', text: '471 - Pre-invoiced amount' },
  { value: '472', text: '472 - Amount accumulated' },
  { value: '473', text: '473 - Deductible amount' },
  { value: '474', text: '474 - Postage' },
  { value: '475', text: '475 - Earlier debit amount' },
  { value: '476', text: '476 - Opening value date balance' },
  { value: '477', text: '477 - Closing value date balance' },
  { value: '478', text: '478 - Schedule variance' },
  { value: '479', text: '479 - Schedule variance cumulative' },
  { value: '480', text: '480 - Total debit charges (5)' },
  { value: '481', text: '481 - Total credit allowances (5)' },
  { value: '482', text: '482 - Total debit charges (6)' },
  { value: '483', text: '483 - Total credit allowances (6)' },
  { value: '484', text: '484 - Total debit charges (7)' },
  { value: '485', text: '485 - Total credit allowances (7)' },
  { value: '486', text: '486 - Total debit charges (8)' },
  { value: '487', text: '487 - Total credit allowances (8)' },
  { value: '488', text: '488 - Total charges not elsewhere specified' },
  { value: '489', text: '489 - Total allowances not elsewhere specified' },
  { value: '490', text: '490 - Late delivery penalty' },
  { value: '491', text: '491 - Debt financing cost' },
  { value: '492', text: '492 - Debt financing amount' },
  { value: '493', text: '493 - Cancellation charge' },
  { value: '494', text: '494 - Incurred cost' },
  { value: '495', text: '495 - Accrued overdraft interest' },
  { value: '496', text: '496 - Total returnable amount' },
  { value: '497', text: '497 - Goods and services tax (2)' },
  { value: '498', text: '498 - Waiting time indemnity' },
  { value: '499', text: '499 - Total net amount' },
  { value: '500', text: '500 - Interest on late payment' },
  { value: '501', text: '501 - Interest on late payment (2)' },
  { value: '502', text: '502 - Taxable disbursement amount' },
  { value: '503', text: '503 - Contract total amount' },
  { value: '504', text: '504 - Daily contribution' },
  { value: '505', text: '505 - Rental amount' },
  { value: '506', text: '506 - Gross progress payment' },
  { value: '507', text: '507 - Net progress payment' },
  { value: '508', text: '508 - Value of returned goods' },
  { value: '509', text: '509 - Unit allowance amount' },
  { value: '510', text: '510 - Remaining available credit' },
  { value: '511', text: '511 - Unit charge amount' },
  { value: '512', text: '512 - Agreed monetary amount (2)' },
  { value: '513', text: '513 - Dossier amount' },
  { value: '514', text: '514 - Amount for pre-authorization' },
  { value: '515', text: '515 - Supplement' },
  { value: '516', text: '516 - Debit balance at close' },
  { value: '517', text: '517 - Credit balance at close' },
  { value: '518', text: '518 - Debit balance at open' },
  { value: '519', text: '519 - Credit balance at open' },
  { value: '520', text: '520 - Total of debit balances (close)' },
  { value: '521', text: '521 - Total of credit balances (close)' },
  { value: '522', text: '522 - Total of debit balances (open)' },
  { value: '523', text: '523 - Total of credit balances (open)' },
  { value: '524', text: '524 - Cost accounting amount' },
  { value: '525', text: '525 - Tariff' },
  { value: '526', text: '526 - Volume discount' },
  { value: '527', text: '527 - Product range discount' },
  { value: '528', text: '528 - Calculation basis amount (1)' },
  { value: '529', text: '529 - Calculation basis amount (2)' },
  { value: '530', text: '530 - Refund' },
  { value: '531', text: '531 - Total returnable packaging' },
  { value: '532', text: '532 - Total Marine Diesel Oil charges' },
  { value: '533', text: '533 - Total Marine Diesel Oil refund' },
  { value: '534', text: '534 - Total Intermediate Fuel Oil charges' },
  { value: '535', text: '535 - Total Intermediate Fuel Oil refund' },
  { value: '536', text: '536 - Total Bunker C oil charges' },
  { value: '537', text: '537 - Total Bunker C oil refund' },
  { value: '538', text: '538 - Government agency fee' },
  { value: '539', text: '539 - Valuation adjustment' },
  { value: '540', text: '540 - Damage allowance' },
  { value: '541', text: '541 - Air transport freight' },
  { value: '542', text: '542 - Unloading and handling charges' },
  { value: '543', text: '543 - Commission and brokerage' },
  { value: '544', text: '544 - Taxable amount (type 1)' },
  { value: '545', text: '545 - Must buy product value' },
  { value: '546', text: '546 - Additional voluntary contribution' },
  { value: '547', text: '547 - Interest amount (2)' },
  { value: '548', text: '548 - Prepaid amount related to transport' },
  { value: '549', text: '549 - Amount to be compensated' },
  { value: '550', text: '550 - Bank check amount' },
  { value: 'ZZZ', text: 'ZZZ - Mutually defined' }
]
